<script setup>
import { useUserStore } from '~/stores/user'
import { useBlogStore } from '~/stores/blog'
import { useRouteStore } from '~/stores/route'
import BaseBanner from '~/components/banners/BaseBanner'
import BlogBecomeMemberBanner from '~/components/banners/BlogBecomeMemberBanner'
import Breadcrumb from '~/components/Breadcrumb'

const userStore = useUserStore()
const blogStore = useBlogStore()
const routeStore = useRouteStore()
const route = useRoute()
const slug = computed(() => route.params.slug)
const blogPost = computed(() => blogStore.blogPostDetails)
const loggedInUser = computed(() => userStore.loggedInUser)
const routeFrom = computed(() => routeStore.from)
const breadcrumbLink = computed(() => {
  const prevPage = routeFrom.value?.query.page

  if (prevPage) {
    return `/boekenpraat?page=${prevPage}`
  }

  return `/boekenpraat`
})

const { error } = await useAsyncData(
  slug.value,
  () => blogStore.getBlogPost(slug.value),
  { default: () => ({}) }
)

if (error.value) {
  throw createError({
    fatal: true,
    statusCode: error.value.statusCode,
    statusMessage: error.value.statusMessage
  })
}

useHead({
  title: `${blogPost.value.title} • Boekenpraat • Bookchoice`,
  meta: [
    {
      name: 'description',
      content: blogPost.value.shortDescription
    }
  ]
})
</script>

<template>
  <div>
    <BaseBanner :title="blogPost.title" :subtitle="blogPost.subTitle" />

    <div class="container mt-40">
      <div class="mb-24 mb-md-40">
        <Breadcrumb :link="breadcrumbLink" :text="$label('blog.breadcrumb')" />
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="overflow-hidden" v-html="blogPost.mainContent"></div>
        </div>
      </div>

      <div v-if="!loggedInUser" class="mt-40">
        <BlogBecomeMemberBanner />
      </div>
    </div>
  </div>
</template>
